import { render } from "./RecoveryPasswordStep1.vue?vue&type=template&id=64e70b53"
import script from "./RecoveryPasswordStep1.vue?vue&type=script&lang=js"
export * from "./RecoveryPasswordStep1.vue?vue&type=script&lang=js"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/bylex_platform/account/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__